
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"71","height":"53","viewBox":"0 0 71 53","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M69.5074 8.82258C68.7006 5.75806 66.2801 3.33871 63.2142 2.49194C57.6875 1 35.5 1 35.5 1C35.5 1 13.3125 1 7.74545 2.49194C4.67955 3.29839 2.29943 5.71774 1.45227 8.82258C0 14.3871 0 26 0 26C0 26 0 37.6129 1.49261 43.1774C2.29943 46.2419 4.71989 48.6613 7.7858 49.5081C13.3125 51 35.5 51 35.5 51C35.5 51 57.6875 51 63.2545 49.5081C66.3205 48.7016 68.7006 46.2823 69.5477 43.1774C71 37.6129 71 26 71 26C71 26 71 14.3871 69.5074 8.82258Z"}}),_c('path',{attrs:{"d":"M28.2386 36.5646L46.7955 26.0001L28.2386 15.4355V36.5646Z","fill":"white"}})])
          )
        }
      }
    